module.exports = __webpack_public_path__ + "img/sticker-en10x10.032b039a.jpg";